// Search Method Handler
export function ToggleHandler(toggle, setToggle) {
  if (toggle) setToggle(false);
  else setToggle(true);
}
